<template>
  <div
    v-if="view === 'image'"
    class="com-anm22-app-product-icon-box product"
    :style="{ cursor: 'pointer', opacity: disabled ? '0.3' : '' }"
    @click="!disabled ? onclick(product) : ''"
  >
    <img
      v-if="product.img"
      :src="$anm22.getImagePath(product.img)"
      :class="['com-anm22-app-product-icon-img', imgType]"
    />
    <div class="com-anm22-app-product-icon-text-div">
      <div class="com-anm22-app-product-icon-text com-anm22-app-text-l">
        {{ product.langName }}
      </div>
      <div
        class="com-anm22-app-product-icon-text com-anm22-app-text-l"
        style="color: #90a4ae"
      >
        {{
          product.price.toFixed(2) +
          (product.pricingType === 2
            ? " / " +
              $anm22.tableClasses.foodUnitOfMeasurement().getById(product.uom)[
                "typeClassLiteral"
              ]
            : "")
        }}
      </div>
    </div>
  </div>
  <div
    v-else
    class="com-anm22-food-fc-prod-list-new product"
    :style="{ cursor: 'pointer', opacity: disabled ? '0.3' : '' }"
    @click="!disabled ? onclick(product) : ''"
  >
    <div
      class="display-flex com-anm22-food-fc-prod-left-div"
      :style="{ backgroundColor: product.color }"
    >
      <img
        v-if="product.icon"
        class="com-anm22-app-img-fixed-height-m"
        :src="$anm22.getImagePath(product.icon)"
      />
    </div>
    <div
      class="wg-row"
      style="flex-direction: column; justify-content: center; padding: 0 10px"
    >
      <div class="com-anm22-app-text-l">{{ product.langName }}</div>
      <div class="vertical-height-div" style="height: 2px"></div>
      <div class="wg-row" style="color: #90a4ae">
        <div class="com-anm22-app-text-m">
          {{
            product.price.toFixed(2) +
            (product.pricingType === 2
              ? " / " +
                $anm22.tableClasses
                  .foodUnitOfMeasurement()
                  .getById(product.uom)["typeClassLiteral"]
              : "")
          }}
        </div>
        <div
          v-if="product.stockType === 2"
          class="com-anm22-app-text-m"
          style="margin-left: auto"
        >
          {{ product.quantity }}
        </div>
        <div
          v-if="product.stockType === 3"
          class="com-anm22-app-text-m"
          style="margin-left: auto"
        >
          {{
            product.quantity +
            $anm22.tableClasses.foodUnitOfMeasurement().getById(product.uom)[
              "typeClassLiteral"
            ]
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    view: String,
    product: Object,
    onclick: Function,
    elements: Array,
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
    }),
    disabled: function () {
      let qntCondition = false,
        qnt = 0;
      switch (this.product.stockType) {
        case 1:
          qntCondition = false;
          break;
        case 2:
          // quantità degli elementi non ancora salvati
          qnt = this.elements.filter(
            (e) => e.product === this.product.id && e.toInsert
          ).length;
          qntCondition =
            this.product.quantity <= 0 || qnt >= this.product.quantity;
          break;
        case 3:
          qnt = this.elements
            .filter((e) => e.product === this.product.id && e.toInsert)
            .reduce((carry, e) => {
              return carry + e.weight;
            }, 0);
          qntCondition =
            this.product.quantity <= 0 || qnt >= this.product.quantity;
          break;
      }
      return this.product.status === 3 || qntCondition;
    },
    imgType() {
      return this.$anm22
          .getImagePath(this.product.img)
          .indexOf(
            process.env.VUE_APP_BACK_DOMAIN +
              process.env.VUE_APP_BACK_BASE_URL +
              "utilities/img/"
          ) === -1
        ? "custom-img"
        : "";
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.product {
  transition: background-color 0.4s;
  .disabled {
    transition: none;
  }
  &:active {
    background-color: rgb(10, 171, 244) !important;
    transition: 0s;
  }

  .com-anm22-app-product-icon-img.custom-img {
    padding: 0;
    object-fit: cover;
    object-position: center;
  }
}
</style>
